import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import RoundedButtonPrimary from '../../../../components/button/rounded-button-primary/RoundedButtonPrimary';
import RoundedButtonSecondary from '../../../../components/button/rounded-button-secondary/RoundedButtonSecondary';
import ButtonText from '../../../../components/button/button-text/ButtonText';
import { goToNextField, goToPreviousField, isOnFirstField } from '../payment-wizard-model';
import styles from './NavigationButtons.module.less';

export const NavigationButtons = ({
    onSave,
    currentField,
    customGoToField,
    onCancel,
    showSave = true,
    canSave = true,
    goNextText = 'Neste',
    goToPreviousText = 'Forrige',
    wizardFields = [],
}) => {
    const navigate = useNavigate();
    const [isHandlingSave, setIsHandlingSave] = useState(false);

    const onSaveClick = async (e) => {
        if (isHandlingSave) {
            e.preventDefault();
        } else if (onSave) {
            setIsHandlingSave(true);
            try {
                const saved = await onSave(e);
                if (saved) {
                    goToNextField({ currentField, navigate, wizardFields });
                } else {
                    setIsHandlingSave(false);
                }
            } catch (e) {
                setIsHandlingSave(false);
            }
        } else {
            goToNextField({
                currentField,
                navigate,
                customGoToField,
                wizardFields,
            });
        }
    };

    const onCancelClick = async (e) => {
        e.preventDefault();
        onCancel();
    };

    return (
        <div className={styles.buttons}>
            <div className={styles.navigationButtons}>
                {showSave && (
                    <RoundedButtonPrimary onClick={onSaveClick} disabled={!canSave}>
                        {goNextText}
                    </RoundedButtonPrimary>
                )}
                {!isOnFirstField(currentField, wizardFields) && (
                    <RoundedButtonSecondary onClick={() => goToPreviousField({ currentField, navigate, wizardFields })}>
                        {goToPreviousText}
                    </RoundedButtonSecondary>
                )}
            </div>
            {!!onCancel && (
                <ButtonText onClick={onCancelClick} className={styles.cancelButton}>
                    Avbryt
                </ButtonText>
            )}
        </div>
    );
};
